import { isEmpty } from 'lodash';
import { XEAError } from './xea-error.model';
import { I18n } from '@app/i18n/strings-keys';
import { I18nService } from '@app/shared/services/i18n/i18n.service';

export class XEAConnectionError extends XEAError {
  public title: string;

  public constructor(params: {
    errorMessage?: string;
    i18nService: I18nService;
  }) {
    const { errorMessage, i18nService } = params;
    super(
      i18nService.t(
        isEmpty(errorMessage)
          ? i18nService.instant(I18n.CommonErrors.ConnectionErrorMessage)
          : errorMessage,
      ),
    );
    this.title = i18nService.instant(I18n.CommonErrors.ConnectionErrorTitle);
  }
}
